import Image from 'next/image';

import { staticMediaStoreBaseURL } from '@/config/common';

const ReadMeArticle = () => (
  <div className='pb-1 w-full pt-5'>
    <div className='flex items-center'>
      <span className='text-base font-semibold text-left blog-font-style'>
        Read Full Article
      </span>
      <div className='relative ms-1.5 h-2.6 flex pl-1'>
        <Image
          alt='right-angle'
          src={`${staticMediaStoreBaseURL}/icons/arrowright.svg`}
          height={10}
          width={14}
        />
      </div>
    </div>
  </div>
);

export default ReadMeArticle;
